// ? [REVISIT] eventually we want `getProductBySelections`

import { find } from 'lodash-es';
import { IColorwayProductData, IPdpData, TUserSelection } from '../types/PDP';

/**
 * Gets the currently selected product, is guaranteed to return a product
 */
export const getProductsDataByColorSelection = (pdpData: IPdpData, userSelections: Partial<TUserSelection>[]) =>
  pdpData.products.map((product, index) => product.productDataByColorName[userSelections[index]?.Color!]); // * [IMPROVEMENT] 2) move into 'utils' once it's cleaned up
// ? consider `userSelections: Partial<TUserSelection>[]` vs `userSelections: TUserSelections`

export const getVariantsBySelections = (pdpData: IPdpData, userSelections: Partial<TUserSelection>[]) =>
  pdpData.products.map(
    (product, index) =>
      find(product.variants, {
        selectionOptions: userSelections[index],
      }) // * [IMPROVEMENT] don't assume 'Color' & 'Size' as the options
  );

export const isStandardExclusion = (product: IColorwayProductData | undefined, parentTags: string[]) => {
  if (!product) return true;
  const { vendor, productType, title, tags } = product;
  const lowercaseTitle = title.trim().toLowerCase();
  const lowercaseParentTags = parentTags.map((t) => t.toLowerCase());
  const lowercaseTags = tags.map((t) => t.toLowerCase());
  return (
    vendor.toLowerCase() !== 'alo yoga' ||
    ['gift card', 'internal'].includes(productType.toLowerCase()) ||
    lowercaseParentTags.includes('policy:forcedmatchingset') ||
    lowercaseParentTags.includes('policy:discountedset') ||
    lowercaseTags.includes('policy:standardexclusion') ||
    lowercaseTitle.includes('gift of glow') ||
    lowercaseTitle.includes('alo moves')
  );
};
